import { Request } from '@shuwen/wenlv-web-activity-library';
import { IGetData } from "@/services/interfaces";
import { EventCardInfo, HomePlaceInfo, PageMode } from '@/store/types';
import { getAssetUrl } from '@/utils/common';
import { qrCodeList } from '@/components/QrCode/instance';
import { withCache } from './cache';




// 注册请求
export const sendRequest = new Request({
  Api: process.env.REACT_APP_API as string,
  AccessKey: process.env.REACT_APP_ACCESS_KEY as string,
  SecretKey: process.env.REACT_APP_SECRET_KEY as string,
  Method: 'POST',
  OSSApi: 'https://vlog-api.shuwen.com',
});
const Action = {
  // getData: '/vlog-data-service/api/project/common/groot/entitySearch',
  getData: '/vlog-data-service/api/project/common/groot/entitySearch'
};

const commonParams = {
  uid: '370257446254441477',
  graph: 'xihu_cw',
  // entitySearch: {
  // label: 'event',
  // fetchMaterial: true,
  // includeFields,
  // fetchNeighbour: true,
  // queryString: 'tags:一木一石\\:时间轴',
  // size: 1000,
  // }
}

const includeFields = [
  'entity_id',
  'name',
  'summary',
  'date',
  'year',
  'time',
  'occur_time',
  'struct_address',
  'latitude',
  'longitude',
  'image',
  'dynasty',
  'type',
  // 'image',
  // 'ext_materialList',
  // 'birth_date',
  'tags',
  // 'home_address',
  // 'nationality',
  // 'resume',
  // 'alias',
  // 'display_name',
];

// export const getData = async (params: { activityId?: string; deviceId?: string }) => {
//   const data = await sendRequest.request<IGetData>(Action.getData, {
//     ...params,
//     uid: '355219322049683475',
//     graph: 'ywjmg',
//     entitySearch: {
//       label: 'event',
//       // fetchMaterial: true,
//       includeFields,
//       // fetchNeighbour: true,
//       queryString: 'tags:一木一石\\:时间轴',
//       size: 1000,
//       sortField: "year",
//       sortMode: "DESC",
//     }
//   });
//   if (data?.itemList) {
//     data.itemList = data?.itemList?.sort((a, b) => {
//       return Number(b.year) - Number(a.year);
//     });

//   }
//   return data;
// };
export const getLandmark = async (params:{activityId?:string;deviceId?:string},isLocalData?:boolean) => {
  // 本地数据分支：读静态 json，不走缓存
  if(isLocalData){
    const data = (await getLocalJson('json/local_data.json'))?.data;
    return data?.itemList as HomePlaceInfo[]|undefined;
  }
  // 网络分支：IndexedDB 缓存
  return withCache<HomePlaceInfo[]|undefined>('landmark', async () => {
    const data = await sendRequest.request<any>(Action.getData, {
    ...params,
    uid: '370257446254441477',
    graph: 'xihu_cw',
    entitySearch: {
      label: 'addr',
      fetchMaterial: true,
      includeFields:[...includeFields,'biz_info'],
      fetchNeighbour: true,
      queryString: 'tags:展示地标 OR tags:首页轮播',
      size: 1000,
      sortField: "create_time",
      sortMode: "DESC",
      neighbourSearch: {
        relNames: ['相关'],
        neighborLabels:['creative_work','ppl'],
        // fetchMaterial: true,
        relQueryString: 'tags:展示地标', // TODO: 这里要加上展示地标的关系筛选
        // size: 5,
        props: ['author', 'dynasty', 'image', 'content', 'entity_id', 'name', 'summary','tags'],
      },
    }
    });
    return data?.itemList as HomePlaceInfo[]|undefined;
  });
};
export const getMajorEvents = async (params:{activityId?:string;deviceId?:string}) => {
  return withCache<EventCardInfo[]|undefined>('major_events', async () => {
    const data = await sendRequest.request<any>(Action.getData, {
      ...params,
      activityId: "test",
      uid: '370257446254441477',
      graph: 'xihu_cw',
      entitySearch: {
        label: 'event',
        fetchMaterial: false,
        includeFields,
        fetchNeighbour: true,
        queryString: 'tags:西湖大事件',
        size: 100,
        sortField: "create_time",
        sortMode: "DESC",
      }
    });
    return data?.itemList as EventCardInfo[]|undefined;
  });
};
export const getLocalJson = async (url: string) => {
  const newUrl = getAssetUrl(url);
  return fetch(newUrl).then(res => res.json());
};

export const getAgentData = async (query: string) => {
  const data = await sendRequest.originRequest<IAgentData, any>('https://api.shuwen.com/agent/api/workflow', {
    method: 'POST',
    body: {
      "inputs": {
        "query": query
      },
      "response_mode": "blocking",
      "app_id": "711ff29e-9235-4560-ad6f-31c943a447c2",
      "user": "277477244611337217,277477244611337217"
    }
  }, 'v2');
  return data;
}
// 所有路线
export const getAllRoute = async () => {
  return withCache('all_route', async () => {
    const data = await sendRequest.request<IGetData>(Action.getData, {
      ...commonParams,
      entitySearch: {
        label: 'addr',
        fetchMaterial: true,
        includeFields: ['biz_info', 'content', 'entity_id', 'hot', 'name', 'summary', 'tags', 'image', 'short_summary'],
        queryString: 'tags:人物路线 OR tags:主题路线',
      }
    });

    if (data?.itemList) return {
      charaterList: data.itemList.filter(i => i.tags.includes('人物路线'))
      .map((item) => {
        const image = qrCodeList.find(q => q.id === item.entity_id)?.image || '';
        return {
          ...item,
          image
        }
      }),
      themeList: data.itemList.filter(i => i.tags.includes('主题路线')).map((item) => {
        const image = qrCodeList.find(q => q.id === item.entity_id)?.image || '';
        return {
          ...item,
          image
        }
      }),
    };
    return { charaterList: [], themeList: [] };
  });
}

// 查看特定路线的时间轴
export const getTargetList = async (str: string,relParamsQuery?:string) => {
  // const queryString = mode === PageMode.ROUTE_CHARACTER_LIST ? `tags:路线实体\\:${name}线路` : `tags:路线实体\\:${name}`;
  const data = await sendRequest.request<IGetData>(Action.getData, {
    ...commonParams,
    entitySearch: {
      label: 'addr',
      // fetchMaterial: true,
      fetchNeighbour: true,
      neighbourSearch: {
        relNames: ['相关'],
        relQueryString: relParamsQuery,
        size: 300,
        props: ['entity_id', 'name', 'content', 'summary', 'author', 'dynasty', 'image','historical_era']
      },
      includeFields: ['author', 'dynasty', 'content', 'entity_id', 'name', 'summary', 'image', 'type', 'biz_info'],
      queryString: str,
    }
  });

  if (data?.itemList) return data.itemList;
  return [];
}


export type IAgentData = {
  query: string;
  response: string;
  task_id?: string;
  workflow_run_id?: string;
  data?: {
    id: string;
    workflow_id: string;
    status: string;
    outputs: {
      mode: string;
      tour: null | string;
      person: string;
      location: string;
      event: string;
      start_time: string;
      end_time: string;
      card: string;
      theme: string;
      tour_id: null | string;
      location_id: null | string;
      event_id: null | string;
    };
    error: null | string;
    elapsed_time: number;
    total_tokens: number;
    total_steps: number;
    created_at: number;
    finished_at: number;
  };
}

export type IAgentDataOutputs = NonNullable<IAgentData['data']>['outputs']

